import { useEffect } from 'react'
import { useFormContext } from 'react-hook-form'
import {
  FormControl,
  FormField,
  FormItem,
  FormMessage,
} from '@/components/ui/form'
import { Label } from '@/components/ui/label'
import { RadioGroup, RadioGroupItem } from '@/components/ui/radio-group'
import { cn } from '@/lib/utils'
import {
  MariaDBLogo,
  MySQLLogo,
  PostgreSQLLogo,
  RedisLogo,
  ValkeyLogo,
} from '@/logos'
import type { CreateDatabaseFormValues } from '@/routes/databases/create-database/form/schema'

export const Type = () => {
  const form = useFormContext<CreateDatabaseFormValues>()
  const { resetField } = form

  useEffect(() => {
    return () => {
      resetField('type')
    }
  }, [resetField])

  return (
    <FormField
      control={form.control}
      name="type"
      render={({ field: { value, onChange } }) => (
        <>
          <FormItem>
            <FormControl>
              <RadioGroup
                className="grid grid-cols-5 gap-3"
                onValueChange={onChange}
                value={value}
              >
                <Label
                  className={cn(
                    'cursor-pointer relative has-[[data-state=checked]]:border-ring has-[[data-state=checked]]:bg-input/20',
                    'flex flex-col items-center justify-center gap-3 rounded-lg border px-3 py-6'
                  )}
                  key="postgresql"
                >
                  <RadioGroupItem
                    value="postgresql"
                    id="postgresql"
                    className="absolute top-3 left-3 data-[state=checked]:border-primary"
                  />
                  <div className="grid gap-2 text-center place-items-center font-normal">
                    <div className="flex items-center gap-2">
                      <PostgreSQLLogo className="size-7" />
                    </div>
                    <div className="font-medium">PostgreSQL</div>
                  </div>
                </Label>
                <Label
                  className={cn(
                    'cursor-pointer relative has-[[data-state=checked]]:border-ring has-[[data-state=checked]]:bg-input/20',
                    'flex flex-col items-center justify-center gap-3 rounded-lg border px-3 py-6'
                  )}
                  key="mysql"
                >
                  <RadioGroupItem
                    value="mysql"
                    id="mysql"
                    className="absolute top-3 left-3 data-[state=checked]:border-primary"
                  />
                  <div className="grid gap-2 text-center place-items-center font-normal">
                    <div className="flex items-center gap-2">
                      <MySQLLogo className="size-7" />
                    </div>
                    <div className="font-medium">MySQL</div>
                  </div>
                </Label>
                <Label
                  className={cn(
                    'cursor-pointer relative has-[[data-state=checked]]:border-ring has-[[data-state=checked]]:bg-input/20',
                    'flex flex-col items-center justify-center gap-3 rounded-lg border px-3 py-6'
                  )}
                  key="mariadb"
                >
                  <RadioGroupItem
                    value="mariadb"
                    id="mariadb"
                    className="absolute top-3 left-3 data-[state=checked]:border-primary"
                  />
                  <div className="grid gap-2 text-center place-items-center font-normal">
                    <div className="flex items-center gap-2">
                      <MariaDBLogo className="size-7" />
                    </div>
                    <div className="font-medium">MariaDB</div>
                  </div>
                </Label>
                <Label
                  className={cn(
                    'cursor-pointer relative has-[[data-state=checked]]:border-ring has-[[data-state=checked]]:bg-input/20',
                    'flex flex-col items-center justify-center gap-3 rounded-lg border px-3 py-6'
                  )}
                  key="redis"
                >
                  <RadioGroupItem
                    value="redis"
                    id="redis"
                    className="absolute top-3 left-3 data-[state=checked]:border-primary"
                  />
                  <div className="grid gap-2 text-center place-items-center font-normal">
                    <div className="flex items-center gap-2">
                      <RedisLogo className="size-7" />
                    </div>
                    <div className="font-medium">Redis</div>
                  </div>
                </Label>
                <Label
                  className={cn(
                    'cursor-pointer relative has-[[data-state=checked]]:border-ring has-[[data-state=checked]]:bg-input/20',
                    'flex flex-col items-center justify-center gap-3 rounded-lg border px-3 py-6'
                  )}
                  key="valkey"
                >
                  <RadioGroupItem
                    value="valkey"
                    id="valkey"
                    className="absolute top-3 left-3 data-[state=checked]:border-primary"
                  />
                  <div className="grid gap-2 text-center place-items-center font-normal">
                    <div className="flex items-center gap-2">
                      <ValkeyLogo className="size-7" />
                    </div>
                    <div className="font-medium">Valkey</div>
                  </div>
                </Label>
              </RadioGroup>
            </FormControl>
            <FormMessage />
          </FormItem>
        </>
      )}
    />
  )
}
